import { render } from "./LabelPill.vue?vue&type=template&id=0bcedbc8"
import script from "./LabelPill.vue?vue&type=script&lang=js"
export * from "./LabelPill.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__